import { Alert, Snackbar } from "@mui/material";
import { useSnackbar } from "../../data/providers/SnackbarProvider";

export function AppSnackbar() {
  const snackbar = useSnackbar();

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={snackbar.hideSnackbar}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={snackbar.hideSnackbar}
        severity={snackbar.severity}
        sx={{ width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
